export default __webpack_public_path__ + "static/media/arrow.2fa81bc2.svg";